import React, { useState } from 'react';
import { Offcanvas, Nav, Button } from 'react-bootstrap';
import { useLogout } from '@/portal/hooks/useLogout.ts';

const SidebarContent = () => {
  const logout = useLogout();

  return (
    <>
      <Nav className="flex-column">
        <Nav.Link href="/portal/providers">Providers</Nav.Link>
        <Nav.Link href="/portal/settings">Settings</Nav.Link>
      </Nav>
      <div className="mt-4">
        <Button variant="outline-danger" className="w-100" onClick={logout}>
          Logout
        </Button>
      </div>
    </>
  );
};

const LeftSidebar: React.FC = () => {
  const [show, setShow] = useState(false);

  return (
    <>
      {/* Desktop sidebar */}
      <div
        className="bg-light border-end p-3 d-none d-md-block"
        style={{ width: '240px', minHeight: '100%' }}
      >
        <SidebarContent />
      </div>

      {/* Mobile sidebar toggle (hamburger) */}
      <Button
        variant="outline-light"
        onClick={() => setShow(true)}
        className="d-md-none position-absolute top-0 start-0 m-2"
      >
        ☰
      </Button>

      {/* Mobile Offcanvas sidebar */}
      <Offcanvas
        show={show}
        onHide={() => setShow(false)}
        responsive="md"
        className="d-md-none"
        scroll={true}
        backdrop={true}
        placement="start"
      >
        <Offcanvas.Header closeButton className="bg-dark-subtle">
          <Offcanvas.Title>Portal Navigation</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <SidebarContent />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default LeftSidebar;
